import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="settings"
export default class SettingsController extends Controller {
  connect() {
    this.element.addEventListener('turbo:submit-start', this.disableForm)
    this.element.addEventListener('turbo:submit-end', this.enableForm)
  }

  disableForm = () => {
    this.element.querySelectorAll('input').forEach(el => {
      el.disabled = true
    })
  }

  enableForm = () => {
    this.element.querySelectorAll('input').forEach(el => {
      el.disabled = false
    })
  }

  toggle() {
    this.element.requestSubmit()
  }
}
